import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {
    loading: false,
    brands: [],
    partners: [],
    partnersExpire: null,
    payPalRewards: [],
    payPalRewardsLoading: false,
    payPalCurrencies: [],
    payPalCurrenciesLoading: false,
    tangoCardRewards: []
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

